module.exports = __webpack_public_path__ + "img/pierres-zen-sont-arriere-plan-pyramide-galets-fond-ciel-mer-plage.c2bc6128.jpg";